let divMenuOpener = document.querySelector('.js-menu-opener');
let divHeader = document.querySelector('.js-header');

let lastScroll = 0;
window.addEventListener('scroll', scrollHeader);

function scrollHeader() {
    let currentScroll = window.scrollY || document.documentElement.scrollTop;
    ((lastScroll === 0 && currentScroll > 100) || (lastScroll === currentScroll) || (currentScroll < lastScroll && currentScroll > 100)) && currentScroll !== 0 ? divHeader.classList.add('header-sticky') : divHeader.classList.remove('header-sticky');
    currentScroll > lastScroll && currentScroll > 50 ? divHeader.classList.add('header-hidden') : divHeader.classList.remove('header-hidden');
    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
}

if (divMenuOpener) {
    divMenuOpener.addEventListener('click', function(event){
        event.preventDefault();
        document.body.classList.toggle('mobile-menu-opener');
    });
}

scrollHeader();

(function() {
    let headerPopupItem = document.querySelectorAll('.js-header-popup-item');
    let headerPopupBody = document.querySelectorAll('.js-header-popup-data');

    if (headerPopupItem) {
        headerPopupItem.forEach(function(item) {
            item.addEventListener('mouseover', function(event) {
                event.preventDefault();
                let type = item.dataset.type;

                headerPopupItem.forEach(function(menu) {
                    menu.classList.remove('active');
                    menu.classList.remove('active-mobile');
                });
                item.classList.add('active');
                item.classList.add('active-mobile');

                if (headerPopupBody) {
                    headerPopupBody.forEach(function(body) {
                        if (body.dataset.type === type) {
                            body.classList.add('active');
                            body.classList.add('active-mobile');
                        } else {
                            body.classList.remove('active');
                            body.classList.remove('active-mobile');
                        }
                    });
                }
            });
        });
    }
})();

document.addEventListener('DOMContentLoaded', function() {

    let popups = document.querySelectorAll('.popup-wrapper');
    let popups_open = document.querySelectorAll('.js-open-popup');
    let popups_close = document.querySelectorAll('.js-popup-close');

    function openPopup(id) {
        let popup = document.getElementById(id);
        if (popup) {
            popup.classList.add('active');
        }
    }

    function closeAllPopups() {

        if (popups.length === 0) {
            return;
        }

        popups.forEach(popup => {
            popup.classList.remove('active');
        });
    }

    if (popups_open.length > 0) {
        popups_open.forEach(popup_open => {
            popup_open.addEventListener('click', function(event) {
                event.preventDefault();
                openPopup(popup_open.getAttribute('data-popup'));
            });
        });
    }

    if (popups_close.length > 0) {
        popups_close.forEach(popup_close => {
            popup_close.addEventListener('click', function() {
                closeAllPopups();
            });
        });
    }

});